"use client";

import { useState, useEffect, useContext, useRef } from "react";
import {
  DashboardHeader,
  SectionTabs,
  ContenidoPrincipal,
} from "./components";
import { dashboardStyles } from "./DashboardWrapper.css.js";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";
import { url } from "../../../env";
import { SelectedPersonComponent } from "./components/SelectedPersonComponent.jsx";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../../Components/index.js";
import { QuoteStepperPanel } from "./components/PreLoanSteps/StepperPanel.jsx";
import RecotizacionDialog from "./components/RecotizacionDialog";
import { PDFViewer } from '@react-pdf/renderer';
import PurchaseOrderPDF from './components/PurchaseOrderPDF';


export default function DashboardWrapper({
  onBack,
  dataBuro,
  setDataBuro,
  setLoading,
  loading,
  toast,
  setSelectedPerson,
  selectedPerson,
  people,
  setPeople,
  onPersonChange,
  categories,
  setCategories,
  setCanContinue,
  canContinue,
  setCategoriasFaltantes,
  categoriasFaltantes,
  onSelectPersonRef,
}) {
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("INICIO");
  const [activeStep, setActiveStep] = useState(0);
  const [currentUser, setCurrentUser] = useState({ current: null });

  const [visible, setVisible] = useState(false);
  const [showPurchaseOrder, setShowPurchaseOrder] = useState(false);
  const [pdfRefreshKey, setPdfRefreshKey] = useState(0);

  // Recotization state
  const [showRecotizacionDialog, setShowRecotizacionDialog] = useState(false);
  const [recotizacionContext, setRecotizacionContext] = useState(null);
  const [activeDraftId, setActiveDraftId] = useState(null);
  const [draftRefreshKey, setDraftRefreshKey] = useState(0);

  // Estados para el modal de documento
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  // Estados para arrastre
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [hasDragged, setHasDragged] = useState(false); // Para detectar si realmente se arrastró
  const { authInfo } = useContext(AuthContext);
  const navigate = useNavigate();

  // SelectedPersonComponent ahora maneja su propia carga paginada

  // Actualizar currentUser cuando cambie selectedPerson
  useEffect(() => {
    if (selectedPerson) {
      setCurrentUser({ current: selectedPerson });
    }
  }, [selectedPerson]);

  // Si selectedPerson llega de afuera (click desde Dashboard cards), disparar fetch de archivos.
  const fetchedForUserRef = useRef(null);
  useEffect(() => {
    if (selectedPerson && fetchedForUserRef.current !== selectedPerson.id) {
      fetchedForUserRef.current = selectedPerson.id;
      onChangePersonFetch(selectedPerson);
    }
  }, [selectedPerson]);

  const handleVerDocumento = (documento, index) => {
    // Mostrar documento en modal de pantalla completa
    setSelectedDocument(documento);
    setZoomLevel(1); // Reset zoom
    setShowDocumentModal(true);
  };

  // Funciones de zoom
  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.25, 3)); // Máximo 300%
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.25, 0.25)); // Mínimo 25%
  };

  const handleResetZoom = () => {
    setZoomLevel(1);
    setDragOffset({ x: 0, y: 0 });
  };

  const closeDocumentModal = () => {
    setShowDocumentModal(false);
    setSelectedDocument(null);
    setZoomLevel(1);
    setDragOffset({ x: 0, y: 0 });
    setIsDragging(false);
    setHasDragged(false);
  };

  // Función para zoom con click simple
  const handleDocumentClick = (event) => {
    // Solo hacer zoom si no se ha arrastrado
    if (!hasDragged) {
      event.preventDefault();
      if (zoomLevel === 1) {
        setZoomLevel(2); // Zoom in al doble
      } else {
        handleResetZoom(); // Reset a 100%
      }
    }
    // Reset el flag de arrastre
    setHasDragged(false);
  };

  // Funciones para arrastre
  const handleMouseDown = (event) => {
    if (zoomLevel > 1) {
      // Solo permitir arrastre si hay zoom
      setIsDragging(true);
      setHasDragged(false); // Reset el flag al iniciar
      setDragStart({
        x: event.clientX - dragOffset.x,
        y: event.clientY - dragOffset.y,
      });
      event.preventDefault();
    }
  };

  const handleMouseMove = (event) => {
    if (isDragging && zoomLevel > 1) {
      const newOffset = {
        x: event.clientX - dragStart.x,
        y: event.clientY - dragStart.y,
      };
      setDragOffset(newOffset);
      setHasDragged(true); // Marcar que se ha arrastrado
      event.preventDefault();
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Limpiar eventos al desmontar
  useEffect(() => {
    if (isDragging) {
      const handleGlobalMouseMove = (e) => handleMouseMove(e);
      const handleGlobalMouseUp = () => handleMouseUp();

      document.addEventListener("mousemove", handleGlobalMouseMove);
      document.addEventListener("mouseup", handleGlobalMouseUp);

      return () => {
        document.removeEventListener("mousemove", handleGlobalMouseMove);
        document.removeEventListener("mouseup", handleGlobalMouseUp);
      };
    }
  }, [isDragging, dragStart]);

  // SOLUCIÓN 1: Descarga directa (más simple y efectiva)
  const handleDescargarDocumento = (documento, index) => { };

  const [loadingFiles, setLoadingFiles] = useState(false);

  // Función para manejar el cambio de persona y obtener URLs prefirmadas
  // Cache para almacenar las categorías de usuarios ya consultados
  const userCategoriesCache = useRef({});

  // Cache para almacenar los datos del buró por usuario
  const buroDataCache = useRef({});

  // Recotization handlers
  const handleOpenRecotizacion = (context) => {
    setRecotizacionContext(context);
    setShowRecotizacionDialog(true);
  };

  const handleDraftSaved = (draftId, cotizadorResult) => {
    setActiveDraftId(draftId);
    setShowRecotizacionDialog(false);
    // Trigger badge refresh in StepperPanel
    setDraftRefreshKey(k => k + 1);

    // Refresh infoBudget from cotizador2 response
    if (cotizadorResult?.infoBudget) {
      const info = cotizadorResult.infoBudget;
      setSelectedPerson(prev => ({
        ...prev,
        infoBudget: {
          ...prev.infoBudget,
          ...info,  // cotizador2 devuelve el infoBudget completo
        }
      }));
    }
  };

  const onChangePersonFetch = async (person) => {
    setLoadingFiles(true);
    if (person) {
      setSelectedPerson(person);
      setCategories([]);
      setCategoriaSeleccionada("INICIO");
      setDataBuro([]);
      setCategoriasFaltantes([]); // Resetear categorías faltantes

      if (person.sections.length === 0) {
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "El usuario no tiene documentos",
          life: 3000,
        });
        setCategoriasFaltantes([`El usuario ${person.name} no tiene documentos disponibles`]);
        setCanContinue(false);
        setLoadingFiles(false);
        return;
      }

      try {
        // Determinar tipo de persona (pf o pm)
        const tipoPersona = person.tipo_persona === "PF" ? "pf" : "pm";
        const userId = person.id;

        // Crear clave única para el cache
        const cacheKey = `${tipoPersona}_${userId}`;

        // Verificar si ya existe en el cache
        if (userCategoriesCache.current[cacheKey]) {
          setCategories(userCategoriesCache.current[cacheKey]["categories"]);
          setCanContinue(userCategoriesCache.current[cacheKey]["canContinue"]);
          setCategoriasFaltantes(userCategoriesCache.current[cacheKey]["categorias_faltantes"]);
          if (userCategoriesCache.current[cacheKey]["company_info"]) {
            person.company_info = userCategoriesCache.current[cacheKey]["company_info"];
          }
          setLoadingFiles(false);
          return;
        }

        // Obtener las categorías disponibles para esta persona
        const response = await axios.get(
          `${url}/pdfs/list/${tipoPersona}/${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const data = response.data;

        if (data.success) {
          // Guardar en cache
          userCategoriesCache.current[cacheKey] = {
            canContinue: data.data.categorias_completas,
            categorias_faltantes: data.data.categorias_faltantes,
            categories: data.data.categories,
            company_info: data.data.company_info,
          };
          setCanContinue(data.data.categorias_completas);

          setCategoriasFaltantes(data.data.categorias_faltantes);

          setCategories(data.data.categories);

          // Attach company_info to persona for use in DiscrepanciaModal
          if (data.data.company_info) {
            person.company_info = data.data.company_info;
            setSelectedPerson({ ...person });
          }
        }
      } catch (error) {
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Error al cargar los documentos del usuario",
          life: 3000,
        });
      } finally {
        setLoadingFiles(false);
      }
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Error al obtener usuario",
        life: 3000,
      });
      setLoadingFiles(false);
      return;
    }
  };

  useEffect(() => {
    if (onSelectPersonRef) {
      onSelectPersonRef.current = onChangePersonFetch;
    }
  });

  return (
    <div
      className="min-h-screen p-3 md:p-4 dashboard-container"
      css={dashboardStyles()}
    >
      {/* Vista selector de personas - sólo monta cuando no hay persona seleccionada para evitar fetch duplicado */}
      {!selectedPerson && (
        <div className="mx-auto" style={{ maxWidth: 1500 }}>
          {loading && <Loader />}
          <SelectedPersonComponent
            setSelectedPerson={onChangePersonFetch}
            setPeople={setPeople}
            setLoading={setLoading}
          />
        </div>
      )}

      {/* Vista mesa de control */}
      {selectedPerson && (
        <div className="mx-auto" style={{ maxWidth: "100%" }}>
          <DashboardHeader
            onBack={onBack}
            onBackToDashboard={() => setSelectedPerson(null)}
            persona={selectedPerson}
            people={people}
            onPersonChange={onChangePersonFetch}
            canContinue={canContinue}
            setCategories={setCategories}
            categoriasFaltantes={categoriasFaltantes}
            visible={visible}
            setVisible={setVisible}
            toast={toast}
          />

          <SectionTabs
            categoriaSeleccionada={categoriaSeleccionada}
            onCategoriaChange={setCategoriaSeleccionada}
            persona={selectedPerson}
            dataBuro={dataBuro}
            toast={toast}
          />

          <div className="flex flex-column">
            <div className="dashboard-main-content">

              <QuoteStepperPanel
                persona={selectedPerson}
                toast={toast}
                categoriasFaltantes={categoriasFaltantes}
                dataBuro={dataBuro}
                categories={categories}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                onOpenRecotizacion={handleOpenRecotizacion}
                draftRefreshKey={draftRefreshKey}
                onDraftChange={() => setDraftRefreshKey(k => k + 1)}
              />

              {/* Recotization Dialog */}
              {showRecotizacionDialog && recotizacionContext && (
                <RecotizacionDialog
                  visible={showRecotizacionDialog}
                  onHide={() => {
                    setShowRecotizacionDialog(false);
                    setRecotizacionContext(null);
                  }}
                  persona={selectedPerson}
                  comparisonData={recotizacionContext.comparisonData}
                  analysisData={recotizacionContext.analysisData}
                  invoiceFileId={recotizacionContext.fileId}
                  toast={toast}
                  onDraftSaved={handleDraftSaved}
                  processId={recotizacionContext.processId || null}
                />
              )}

              <ContenidoPrincipal
                categoriaSeleccionada={categoriaSeleccionada}
                onVerDocumento={handleVerDocumento}
                onDescargarDocumento={handleDescargarDocumento}
                persona={selectedPerson}
                people={people}
                setPeople={setPeople}
                currentUser={currentUser}
                dataBuro={dataBuro}
                setDataBuro={setDataBuro}
                setLoading={setLoading}
                loading={loading}
                toast={toast}
                onChangePersonFetch={onChangePersonFetch}
                setSelectedPersonDirect={setSelectedPerson}
                selectedPerson={selectedPerson}
                categories={categories}
                loadingFiles={loadingFiles}
                buroDataCache={buroDataCache}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal para ver documento en pantalla completa */}
      <Dialog
        visible={showDocumentModal}
        onHide={closeDocumentModal}
        style={{ width: "auto", minWidth: "50vw", height: "95vh" }}
        maximizable={false}
        modal={true}
        dismissableMask={true}
        header={
          <div className="flex align-items-center justify-content-between w-full">
            <div className="flex flex-column">
              <span className="text-xl font-semibold">
                {selectedDocument?.name || "Documento"}
              </span>
              {/*  <span className="text-xs text-gray-500">
                Click: zoom | Arrastrar: mover documento
              </span> */}
            </div>
            <div className="flex gap-2">
              <Button
                icon="pi pi-search-minus"
                onClick={handleZoomOut}
                outlined
                size="small"
                tooltip="Reducir zoom (25%)"
                disabled={zoomLevel <= 0.25}
              />
              <Button
                icon="pi pi-refresh"
                onClick={handleResetZoom}
                outlined
                size="small"
                tooltip="Resetear zoom (100%)"
              />
              <Button
                icon="pi pi-search-plus"
                onClick={handleZoomIn}
                outlined
                size="small"
                tooltip="Aumentar zoom (25%)"
                disabled={zoomLevel >= 3}
              />
              <span className="text-sm text-gray-600 ml-2 align-self-center">
                {Math.round(zoomLevel * 100)}%
              </span>
            </div>
          </div>
        }
        contentStyle={{
          padding: 0,
          height: "calc(95vh - 80px)",
          overflow: "auto",
          backgroundColor: "#f8f9fa",
        }}
      >
        {selectedDocument && (
          <div
            className="w-full h-full flex align-items-center justify-content-center"
            onClick={handleDocumentClick}
            style={{
              cursor: isDragging
                ? "grabbing"
                : zoomLevel > 1
                  ? "grab"
                  : "zoom-in",
              overflow: "hidden",
            }}
          >
            {selectedDocument.name?.toLowerCase().endsWith(".pdf") ? (
              // Para PDFs
              <iframe
                src={`${selectedDocument.signed_url}#toolbar=0&navpanes=0&scrollbar=1`}
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  transform: `scale(${zoomLevel}) translate(${dragOffset.x}px, ${dragOffset.y}px)`,
                  transformOrigin: "center center",
                  minHeight: "100%",
                  pointerEvents: zoomLevel > 1 ? "none" : "auto",
                }}
                title={selectedDocument.name}
                onMouseDown={handleMouseDown}
              />
            ) : (
              // Para imágenes
              <img
                src={selectedDocument.signed_url}
                alt={selectedDocument.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  transform: `scale(${zoomLevel}) translate(${dragOffset.x}px, ${dragOffset.y}px)`,
                  transformOrigin: "center center",
                  objectFit: "contain",
                  userSelect: "none",
                  pointerEvents: "auto",
                }}
                /* onLoad={() => console.log("Imagen cargada")} */
                onError={() => console.error("Error cargando imagen")}
                onMouseDown={handleMouseDown}
                draggable={false}
              />
            )}
          </div>
        )}
      </Dialog>

      {/* Modal para Orden de Compra Temporal */}
      <Dialog
        header={
          <div className="flex align-items-center gap-3">
            <span>Orden de Compra</span>
            <Button
              icon="pi pi-refresh"
              rounded
              text
              severity="secondary"
              aria-label="Refrescar"
              onClick={() => setPdfRefreshKey(prev => prev + 1)}
              tooltip="Recargar PDF"
            />
          </div>
        }
        visible={showPurchaseOrder}
        style={{ width: '90vw', height: '90vh' }}
        onHide={() => setShowPurchaseOrder(false)}
        maximizable
      >
        <PDFViewer key={pdfRefreshKey} width="100%" height="100%" style={{ border: 'none' }}>
          <PurchaseOrderPDF />
        </PDFViewer>
      </Dialog>
    </div >
  );
}
